// extracted by mini-css-extract-plugin
export var container = "Luukku-module--container--k0r7u";
export var kansi = "Luukku-module--kansi--FbZ0-";
export var kannen_tausta = "Luukku-module--kannen_tausta--FK6Es";
export var open = "Luukku-module--open--pDoWX";
export var available = "Luukku-module--available---Mj2+";
export var current = "Luukku-module--current--3qzGN";
export var avatunLuukunNumero = "Luukku-module--avatunLuukunNumero--rVrxi";